"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactUtilService = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
class ReactUtilService {
    createReactComponentAppendToDom(component, targetElement, clearTargetContent = false, props = undefined, children = []) {
        const componentElement = react_1.default.createElement(component, props, children);
        let componentInstance;
        // Append DOM element to the HTML element specified
        if (targetElement) {
            if (clearTargetContent && targetElement.innerHTML) {
                targetElement.innerHTML = '';
            }
            componentInstance = react_dom_1.default.render(componentElement, targetElement);
        }
        else {
            componentInstance = react_dom_1.default.render(componentElement, document.body);
        }
        const domElement = react_dom_1.default.findDOMNode(componentInstance);
        return { componentInstance, componentElement, domElement };
    }
}
exports.ReactUtilService = ReactUtilService;
//# sourceMappingURL=reactUtil.service.js.map